import { isEqual } from 'lodash';
import { useEffect, useLayoutEffect, useRef } from 'react';

export function useDeepCompareMemoize(value: any) {
  const ref = useRef<any>(undefined);
  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

export const useDeepEffect = (callback: () => void, dependencies: any[]) => {
  useEffect(callback, dependencies.map(useDeepCompareMemoize));
};

export const useDeepLayoutEffect = (
  callback: () => void,
  dependencies: any[],
) => {
  useLayoutEffect(callback, dependencies.map(useDeepCompareMemoize));
};